import { compose } from 'redux';
import { connect } from 'react-redux';

import { simoSubPage } from 'decorators/subPage';
import {
  getSimoUpgradePurchaseId,
  getSubmitStatus,
  getSubmitSucceeded,
  getIsAdmin,
  getLoggedInUser,
} from 'reducers';
import SimoSubNav from 'components/SubNav/simo';
import UpgradeInvoice from './UpgradeInvoice';
import { withSimoPlans } from 'decorators/withPlans';
import { upgradePurchaseSimoPlan } from 'actions/purchases';
import { SubmissionError } from 'redux-form';

const mapStateToProps = (state, { subId }) => ({
  loggedInUser: getLoggedInUser(state),
  saveStatus: getSubmitStatus(state, 'upgradeInvoice'),
  redirectUrl: `/simo/subscriptions/${subId}/view`,
  submitSucceeded: getSubmitSucceeded(state, 'upgradeInvoice'),
  SubNav: SimoSubNav,
  upgradePurchaseId: getSimoUpgradePurchaseId(state),
  isAdmin: getIsAdmin(state),
});

const mapDispatchToProps = (dispatch, { subId }) => ({
  onSubmit: (values) => {
    if (!values.plan) {
      throw new SubmissionError({
        plan: 'Required',
      });
    }

    dispatch(
      upgradePurchaseSimoPlan({
        simo_subscription_id: subId,
        simo_plan_id: values.plan,
        set_overdue: true,
        is_upgrade: true,
      }),
    );
  },
});

export default compose(
  simoSubPage,
  withSimoPlans,
  connect(mapStateToProps, mapDispatchToProps),
)(UpgradeInvoice);
